/**
 * Constants for BusinessSearch component
 */

export const MAP_CONFIG = {
  DEFAULT_CENTER: { lat: 14.5995, lng: 120.9842 },
  DEFAULT_ZOOM: 12,
  MARKER_SIZE: 50,
  SELECTED_MARKER_SIZE: 60,
  BOUNDS_EXPANSION_FACTOR: 0.2,
  MAX_ZOOM: 18,
  MIN_ZOOM: 2,
};

export const DEBOUNCE_DELAY = 300; // ms

export const SEARCH_CONFIG = {
  MIN_SEARCH_LENGTH: 2,
  MAX_RESULTS: 50,
  BOUNDS_MAX_RESULTS: 100,
};

export const BUSINESS_FIELDS = {
  SHOP_NAME: 'shopName',
  ADDRESS: 'storeAddress',
  RATING: 'rating',
  REVIEW_COUNT: 'reviewCount',
  STORE_IMAGE: 'storeImage',
  MARKER_POSITION: 'markerPosition',
  DESCRIPTION: 'directions',
  CATEGORIES: 'categories',
  BUSINESS_HOURS: 'businessHours',
  PHONE: 'phone',
  CONTACT_EMAIL: 'contactEmail',
};

export const MAP_CONTAINER_STYLE = {
  width: '100%',
  height: '100vh',
};

export const DEFAULT_BUSINESS_IMAGE = 'path/to/default-business-image.png';

export const BUSINESS_STATUS = {
  OPEN: 'Open',
  CLOSED: 'Closed',
  UNKNOWN: 'Unknown',
};
